/**
 * Trauma — gated by `traumaEnabled` on company config (same pattern as `expertsEnabled` / F2SU).
 * BE applies custom-field eligibility server-side before returning `traumaEnabled`.
 */

/** Employee- and employer-facing trauma UI/routes — company config only. */
export const isTraumaFeatureEnabled = (traumaEnabled?: boolean): boolean => Boolean(traumaEnabled);
